export const STATUS = {
  PENDING: "Pending",
  LOADING: "Loading",
  IMPORTED: "Imported",
  REJECTED: "Rejected",
};
